export default {
  'memberArea.title': 'Member Area',
  'memberArea.to_next_level': 'To Next Level',
  'memberArea.member_info': 'Member Information',
  'memberArea.invoice_carrier': 'Invoice Carrier',
  'memberArea.language': 'Language',
} as Record<string, string>;
